import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import { 
  EVALUATION_STATE_LIST,
  EVALUATION_STATE_SEARCH_ASSESSMENT_LIST,
  EVALUATION_STATE_ADD,
  EVALUATION_STATE_DETAIL,
  EVALUATION_STATE_UPDATE,
  EVALUATION_STATE_UPLOAD_SET
} from '../../actions';
import {
  EvaluationStateListSuccess,
  EvaluationStateListError,
  EvaluationStateSearchAssessmentListSuccess,
  EvaluationStateSearchAssessmentListError,
  EvaluationStateAddSuccess,
  EvaluationStateAddError,
  EvaluationStateDetailSuccess,
  EvaluationStateDetailError,
  EvaluationStateUpdateSuccess,
  EvaluationStateUpdateError,
  EvaluationStateUploadSetSuccess,
  EvaluationStateUploadSetError
} from '../../actions';
 
export function* watchEvaluationStateList() {
  yield takeEvery(EVALUATION_STATE_LIST, onEvaluationStateList);
}

export function* watchEvaluationStateSearchAssessmentList() {
  yield takeEvery(EVALUATION_STATE_SEARCH_ASSESSMENT_LIST, onEvaluationStateSearchAssessmentList);
}

export function* watchEvaluationStateAdd() {
  yield takeEvery(EVALUATION_STATE_ADD, onEvaluationStateAdd);
}

export function* watchEvaluationStateDetail() {
  yield takeEvery(EVALUATION_STATE_DETAIL, onEvaluationStateDetail);
}

export function* watchEvaluationStateUpdate() {
  yield takeEvery(EVALUATION_STATE_UPDATE, onEvaluationStateUpdate);
}

export function* watchEvaluationStateUpload() {
  yield takeEvery(EVALUATION_STATE_UPLOAD_SET, onEvaluationStateUpload);
}

const onEvaluationStateListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_state/list', { 
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEvaluationStateUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_state/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onEvaluationStateSearchAssessmentListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/assessment', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEvaluationStateAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_state/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onEvaluationStateDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_state/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEvaluationStateUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/evaluation_state/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_documents/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_documents/'});
      });
    });
  });
};


function* onEvaluationStateList(data) {
  try {
    const response = yield call(onEvaluationStateListAsync, data.payload);
    yield put(EvaluationStateListSuccess(response.data));
  } catch (error) {
    yield put(EvaluationStateListError(error));
  }
}

function* onEvaluationStateSearchAssessmentList(data) {
  try {
    const response = yield call(onEvaluationStateSearchAssessmentListAsync, data.payload);
    yield put(EvaluationStateSearchAssessmentListSuccess(response.data));
  } catch (error) {
    yield put(EvaluationStateSearchAssessmentListError(error));
  }
}

function* onEvaluationStateAdd(data) {
  try {
      const response = yield call(onEvaluationStateAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EvaluationStateAddSuccess(response.data));
  } catch (error) {
      yield put(EvaluationStateAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onEvaluationStateDetail(data) {
  try {
    const response = yield call(onEvaluationStateDetailAsync, data.payload);
    yield put(EvaluationStateDetailSuccess(response.data.data));
  } catch (error) {
    yield put(EvaluationStateDetailError(error));
  }
}

function* onEvaluationStateUpdate(data) {
  try {
      const response = yield call(onEvaluationStateUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EvaluationStateUpdateSuccess(response.data));
  } catch (error) {
      yield put(EvaluationStateUpdateError(error));
  }
}

function* onEvaluationStateUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onEvaluationStateUploadAsync, file);
    if(response.message ==='success'){
      yield put(EvaluationStateUploadSetSuccess(response));
    }
    else{
      yield put(EvaluationStateUploadSetError(response));
    }
  } catch (error) {
    yield put(EvaluationStateUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchEvaluationStateList),
    fork(watchEvaluationStateSearchAssessmentList),
    fork(watchEvaluationStateAdd),
    fork(watchEvaluationStateDetail),
    fork(watchEvaluationStateUpdate),
    fork(watchEvaluationStateUpload),
  ]);
} 